import { defineStore } from 'pinia'
import storage from '@/utils/storage'
import storeStorage from '@/stores/modules/storeStorage'
import { login } from '@/api/oauth.js'
import { setRefreshToken, setToken } from '@/utils/auth.js'

export const useUserStore = defineStore('user', {
  state: () => ({
    userInfo: {}
  }),
  actions: {
    async login(userForm) {
      try {
        const res = await login(userForm).catch(err => {
          let res = err.response
          if (!res) return
          if (res.status === 400 || res.status === 401) {
            const errorMap = {
              unauthorized: 40001,
              'Bad credentials': 40002,
              invalid_grant: res.data.error_description === 'Bad credentials' ? 40002 : 40003
            }
            return {
              code: !res.data ? 40001 : errorMap[res.data.error] || errorMap[res.data.error_description] || 40001
            }
          }
        })

        if (res && Object.hasOwnProperty.call(res, 'access_token')) {
          if (res.status !== 1) {
            return {
              code: 20001
            }
          }

          setToken(res.access_token)
          setRefreshToken(res.refresh_token)

          let versionInfo = res.versionInfo || {}
          versionInfo.validStartDate = res.validStartDate || ''
          versionInfo.validEndDate = res.validEndDate || ''

          let role = res.role
          if (res.email === 'admin2@airenz.com') {
            role = 2
          }
          this.userInfo = {
            id: res.id,
            fullName: res.firstName + ' ' + res.lastName,
            firstName: res.firstName,
            lastName: res.lastName,
            email: res.email,
            role: role,
            status: res.status,
            scope: res.scope,
            versionInfo: versionInfo,
            mobile: res.mobile,
            allowTaskCreate: res.allowTaskCreate ?? 1,
            allowDoubaoExpertMode: res.allowDoubaoExpertMode ?? 0
          }

          return new Promise(resolve => {
            resolve({
              code: 10000
            })
          })
        } else {
          return res
        }
      } catch (e) {
        this.reset()
        storage.clear()
        storage.clear('storage')

        return {
          code: 9999,
          msg: ''
        }
      }
    },

    setUser(data) {
      this.userInfo = { ...this.userInfo, ...data }
    },

    reset() {
      this.$reset()
    }
  },
  persist: {
    enabled: true,
    strategies: [
      {
        storage: storeStorage
      }
    ]
  }
})

export default useUserStore

